module.exports = __webpack_public_path__ + "img/house.6901b2b4.svg";